module.exports = __webpack_public_path__ + "img/avatar.70e17e57.svg";